"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const LineChartContainer = (theme) => ({
    minWidth: '1020px',
    padding: 20,
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderRadius: 10,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.05)',
});
const LineChartStyle = (theme) => ({
    fontSize: 15,
    axis: {
        ticks: {
            text: {
                fontSize: 12,
                fill: theme === 'dark' ? constants_1.color.white : '#888888',
            },
        },
    },
    legends: {
        text: {
            fontSize: 15,
            fill: theme === 'dark' ? constants_1.color.white : '#888888',
        },
    },
    tooltip: {
        container: {
            background: theme === 'dark' ? constants_1.color.white : '#272936',
            color: theme === 'dark' ? constants_1.color.black : constants_1.color.white,
            fontSize: 15,
        },
    },
});
const PieChartContainer = (theme) => ({
    padding: 20,
    borderRadius: 10,
    width: '28vw',
    minWidth: '544px',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.05)',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
});
const PieChartDetailsText = (theme) => ({
    fontSize: 14,
    display: 'flex',
    direction: 'rtl',
    fontWeight: '600',
    cursor: 'pointer',
    color: theme === 'dark' ? '#49BFBF' : '#BA352C',
});
const PieChartLegends = (color) => ({
    backgroundColor: color,
    borderRadius: 5,
    padding: '2px 8px',
    lineHeight: '20px',
    color: 'white',
    marginRight: 16,
    marginLeft: 9,
});
const PieChartBody = () => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 50%)',
    overflow: 'auto',
    minHeight: '382px',
    height: 'calc(100vh - 560px)',
});
const PieChartContent = {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '170px auto',
};
const PieChartStyle = (theme) => ({
    fontSize: 15,
    textColor: 'blue',
    axis: {
        ticks: {
            text: {
                fontSize: 12,
                fill: theme === 'dark' ? constants_1.color.white : '#888888',
            },
        },
    },
    legends: {
        text: {
            fontSize: 15,
            fill: theme === 'dark' ? constants_1.color.white : '#888888',
        },
    },
    tooltip: {
        container: {
            background: theme === 'dark' ? constants_1.color.white : '#272936',
            color: theme === 'dark' ? constants_1.color.black : constants_1.color.white,
            fontSize: 15,
        },
    }
});
const PieChartBodyLegend = {
    display: 'flex',
    alignItems: 'center', margin: '5px 0px'
};
const PieChartMidleText = (theme) => ({
    fontWeight: '600',
    textAlign: 'center',
    fill: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
});
const progressChartWrapper = {
    columnGap: 16,
    display: 'grid',
    marginBottom: 24,
    alignItems: 'self-end',
    gridTemplateColumns: '82px auto',
};
const progressChartTitle = {
    margin: 0,
    height: 40,
    fontSize: 16,
    display: 'flex',
    fontWeight: 400,
    lineHeight: '16px',
    alignItems: 'center',
};
const progressChartBarLabelWrapper = {
    display: 'flex',
    marginBottom: 8,
    alignItems: 'center',
    justifyContent: 'space-between',
};
const progressChartBarLabel = {
    margin: 0,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
};
const progressChartTargetBar = {
    height: 40,
    width: '100%',
    display: 'flex',
    textAlign: 'right',
    position: 'relative',
    padding: '12px 16px',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: constants_1.color.sidebarItemInactiveLight
};
const progressChartAchievedBar = {
    top: 0,
    left: 0,
    height: 40,
    padding: 0,
    width: '0%',
    display: 'flex',
    textAlign: 'right',
    alignItems: 'center',
    position: 'absolute',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    justifyContent: 'space-between',
};
const progressChartBarValue = {
    margin: 0,
    fontSize: 16,
    fontWeight: 400,
    color: '#F5F5F5',
    lineHeight: '16px',
};
const BarChartContainer = {
    width: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    position: 'relative',
    height: 'calc(100vh - 570px)'
};
const LineChartWrapper = {
    gap: 24,
    display: 'grid',
    gridTemplateColumns: 'auto auto',
};
exports.default = {
    PieChartBody,
    PieChartStyle,
    LineChartStyle,
    PieChartLegends,
    PieChartContent,
    LineChartWrapper,
    BarChartContainer,
    PieChartContainer,
    PieChartMidleText,
    LineChartContainer,
    PieChartBodyLegend,
    progressChartTitle,
    PieChartDetailsText,
    progressChartWrapper,
    progressChartBarLabel,
    progressChartBarValue,
    progressChartTargetBar,
    progressChartAchievedBar,
    progressChartBarLabelWrapper
};
